import cookie from '@/common/utils/cookie'

export const isLogin = () => {
  return cookie.isCsInfo()
}
